import 'bootstrap/dist/css/bootstrap.css';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import ConsigntmentApp from './ConsignmentApp';
import DateConfigProvider from './contexts/DateConfigContext';

ReactDOM.render(
  <React.StrictMode>
    <DateConfigProvider>
      <ConsigntmentApp />
    </DateConfigProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
